// extracted by css-extract-rspack-plugin
export default {"celebrate":"Celebrate-module__celebrate__AH0aNMn","copilotRun":"Celebrate-module__copilotRun__RHD2AHc"};